enum ContractTypes {
  STANDARD = 'Standard',
  CONTRACT_PMG = 'Contrat PMG',
  COMPLEMENT_PMG = 'Complément PMG',
}

export default ContractTypes
